import { createReducer } from 'redux-act';
import { clearData, setPrintTemplateData, setPrintTemplateLoading } from 'redux/actions/PrintTemplates/currentActions';

const initialState = {
  data: {},
  isLoading: false,
};

const viewReducer = createReducer(
  {
    [clearData]: () => ({ ...initialState }),
    [setPrintTemplateData]: (state, data) => ({
      ...state,
      data,
    }),
    [setPrintTemplateLoading]: (state, isLoading) => ({
      ...state,
      isLoading,
    }),
  },
  initialState,
);

export default viewReducer;
